import StudentForm from './StudentForm.container';

export default StudentForm;
